import type { ReactNode } from "react";
import { SlideHeader } from "../../../SlideHeader";

export default function ShapeAndUseOfFunds() {
  return (
    <div className="flex w-full flex-col px-6 pt-8 pb-4 text-slate-900 md:h-full md:px-24 md:pt-16 md:pb-8">
      <SlideHeader eyebrow="The Raise">
        <h1 className="text-3xl font-semibold leading-tight tracking-tight md:text-6xl md:leading-[1.1]">
          €900K pre-seed on a €6M post-money SAFE.
        </h1>
      </SlideHeader>
      <div className="hidden md:block md:flex-1" />

      <div className="grid grid-cols-1 gap-6 border-t border-slate-200 pt-6 md:grid-cols-3 md:gap-12 md:pt-10">
        <Signal label="Team">
          Operator-founders. 30+ years of product and ASO across{" "}
          <span className="font-semibold text-slate-900">
            Netflix, Google, FunPlus, KiloHealth, and Welltech
          </span>
          . EU-based.
        </Signal>
        <Signal label="Traction">
          <span className="font-semibold text-slate-900">Production-live</span>{" "}
          with paying customers and active design partners. Pilot conversations
          underway with major app and game publishers.{" "}
          <span className="font-semibold text-slate-900">
            Impact attribution runs on the customer's own store data
          </span>{" "}
          — conversion and visibility deltas, tied to specific shipped
          recommendations.
        </Signal>
        <Signal label="Why now">
          App discovery is{" "}
          <span className="font-semibold text-slate-900">fragmenting fast</span>{" "}
          — across iOS, Google Play, and the AI surfaces customers now ask
          first. Incumbents rebranded with AI; few have transformed. And both
          ASO inputs —{" "}
          <span className="font-semibold text-slate-900">
            visibility and conversion — decay continuously
          </span>
          . The organic-install gap grows every week.
        </Signal>
      </div>
    </div>
  );
}

function Signal({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-blue-700 md:tracking-[0.2em]">
        {label}
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700 md:mt-3 md:text-lg">
        {children}
      </p>
    </div>
  );
}
